import React, {useCallback, useMemo, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import metadata from './CommercialPropertyCoveragesComponent.metadata.json5';
import messages from './CommercialPropertyCoveragesComponent.messages';
import PolicyDwellingInfo from './../../HO/PolicyDwellingInfo/PolicyDwellingInfo';
import styles from './CommercialPropertyCoveragesComponent.module.scss';

const getFormattedInfo = (message, key, value) => {
    return (
        <FormattedMessage
            {...message}
            values={{
                [key]: value
            }}
        />
    );
};

const getLimitDeductible = (items, property) => {
    let amount = "-";
    items.terms.forEach(function(term) {
        if (term.name.toUpperCase() === property.toUpperCase()) {
            amount = term.amount;
        }
    });
    return amount;
};

const getCellCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};



const getCellBuildingName = (index, rowData) => {
    let bname = '';
    if (rowData) {
        bname = `Building ${index + 1}: ${rowData.name}`;
    }
    return (
        <span>
            {bname}
        </span>
    );
};


function CommercialPropertyCoveragesComponent(props) {
    const { value: cpData } = props;
    const translator = useContext(TranslatorContext);
    const [openItems, setOpenItems] = useState([]);

    if (_.isEmpty(cpData) || cpData === undefined) {
        return null;
    }

    const policyLocationCoverages = useMemo(() => {
        const cpLocations = cpData.locations;
        console.log("locations: ", cpLocations);
        return cpLocations;
    }, [cpData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'myPolicyLocations') {
                return policyLocationCoverages;
            }
            return _.get(policyLocationCoverages, path);
        },
        [policyLocationCoverages]
    );

    /*const getCellCoverageLimit = (rowData) => {
        if (_.isEmpty(rowData.limit)) {
            return (
                <span>
                    {getLimitDeductible(rowData, 'Limit')}
                </span>
            );
        }
        else {
            const formattedLimit = formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(rowData.limit));
            return (
                <span>
                    {formattedLimit}
                </span>
            );
        }
    };*/

    const getCellCoverageLimit = (rowData) => {
        const limit = rowData.limit ? rowData.limit : '-';
        return (
            <span>
            {limit}
        </span>
        );
    };

    /*const getCellCoverageDeductible = (rowData) => {
        if (_.isEmpty(rowData.deductible)) {
            return (
                <span>
                    {getLimitDeductible(rowData, 'Deductible')}
                </span>
            );
        }
        else {
            const formattedDeductible = formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(rowData.deductible));
            return (
                <span>
                    {formattedDeductible}
                </span>
            );
        }
    };*/

    const getCellCoverageDeductible = (rowData) => {
        const deductible = rowData.deductible ? rowData.deductible : '-';
        return (
            <span>
            {deductible}
        </span>
        );
    };

    const trimCharsAnsSpecialChars = (userText) => {
        var regExpr = /[^0-9 ]/g;
        return userText.replace(regExpr, '');
    }

    //Show/Hide package details code -- Start--
    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );

    const updateVisibility = useCallback((val) => {
        console.log('val: ', val);
        if (val && val.length > 0) {
            return true;
        }
        return false;
    }
    );

    const generateBuildingTableOverrides = useCallback((policyLocBuildings) => {
        const overrides = policyLocBuildings.map((building, index) => {
            return {
                [`buildingId${index}`]: {
                    content: getCellBuildingName(index, building)
                }

            };
        });
        return Object.assign({}, ...overrides);
    }, [policyLocationCoverages]);

    const generateCpLocationTableOverrides = useCallback(() => {
        const overrides = policyLocationCoverages ? policyLocationCoverages.map((policyLocation, index) => {
            let cpBuildingData = policyLocation;
            cpBuildingData['dwellingDTO']= policyLocation.buildings;
            return {
                [`buildingCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.buildings)
                },
                [`locationCoveragesTable${index}`]: {
                    data: policyLocation.coverages
                },
                [`locationBuildingsTable${index}`]: {
                    data: policyLocation.buildings
                },
                [`myPolicyLocationBuildings${index}`]: {
                    path: policyLocation.buildings
                },
                ...generateBuildingTableOverrides(policyLocation.buildings),
                [`contentDetailToggle${index}`]: {
                    icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openItems, index)
                        ? translator(messages.hidePackageCoverages)
                        : translator(messages.showPackageCoverages)
                },
                [`packageDetailsID${index}`]: {
                    visible: _.includes(openItems, index),
                    show: openItems
                },
                [`showContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`buildingDetails${index}`]:{
                    value: cpBuildingData,
                    productCode: "Commercial Property"
                },
                [`homeAddressId${index}`]:{
                    content: `${translator(messages.CPLocation)} # ${policyLocation.packageNumber}: ${policyLocation.displayName}`
                }
            };
        }): [];

        return Object.assign({}, ...overrides);
    }, [policyLocationCoverages, openItems, toggleShowHide, translator]);

    const resolveCallbackMap = {
        getCellCoverageName: getCellCoverageName,
        getCellCoverageLimit: getCellCoverageLimit,
        getCellCoverageDeductible: getCellCoverageDeductible,
        getCellBuildingName: getCellBuildingName
    };

    const resolveComponentMap = {
        policyDwellingInfo: PolicyDwellingInfo
    }

    const overrides = {
        repeatLocation: {
            data: policyLocationCoverages
        },
        ...generateCpLocationTableOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyLocationCoverages}
            overrideProps={overrides}
            resolveValue={readValue}
            callbackMap={resolveCallbackMap}
            componentMap={resolveComponentMap}
            classNameMap={styles}
        />
    );
}

CommercialPropertyCoveragesComponent.propTypes = {
    value: PropTypes.shape({})
};

CommercialPropertyCoveragesComponent.defaultProps = {
    value: []
};

export default CommercialPropertyCoveragesComponent;
